module.exports = __webpack_public_path__ + "img/specialize.76a79d3b.png";